import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface actions {
  status: string;
  comment: string;
  date: string;
  
}

@Component({
  selector: 'bid-dialog-comment',
  templateUrl: './dialog-comment.component.html',
  styleUrls: ['./dialog-comment.component.scss']
})
export class DialogCommentComponent implements OnInit {
  displayedColumns: string[] = ['Status', 'Comment', 'Date'];
  dataSource: any;
  constructor(
    public dialogRef: MatDialogRef<DialogCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    console.log('data:',this.data)
    const ELEMENT_DATA: actions[] = [
      {
        status: 'Complete',
        comment: this.data.name.commentStatusCompleted,
        date: this.data.name.dateStatusCompleted
      },
      {
        status: 'In Progress',
        comment: this.data.name.commentStatusInProgress,
        date: this.data.name.dateStatusInProgress
      }
    ]

    this.dataSource = ELEMENT_DATA;
  }

}
